<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            :submit-button-text="data ? 'Update' : 'Create'"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :can-delete="canDelete"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="canCreate"
            :create-route="createRoute"
            :create-value="createValue"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"

            :version-id="versionId"
            :init-version-id="initVersionId"
            :last-updated-by="lastUpdatedBy"
        />

        <input-rich-text
            name="editor_note"
            label="Editor's note"
            v-model="form.editor_note"
            :language="form.language"
            :error="errors.editor_note ? errors.editor_note[0] : null"
            :maxlength="60000"
        />
        <p class="my-1 text-xs text-gray-600 dark:text-gray-300 mb-3">The note is for internal use only and won’t be displayed on the site</p>

        <input-text
            name="name"
            label="* Name"
            v-model="form.name"
            :error="errors.name ? errors.name[0] : null"
            :maxlength="255"
        />

        <input-text
            label="Address"
            name="address"
            class="mt-3"
            v-model="form.address"
            :error="errors.address ? errors.address[0] : null"
            :maxlength="255"
        />

        <input-text
            label="Registration number"
            name="registration_number"
            class="mt-3"
            v-model="form.registration_number"
            :error="errors.registration_number ? errors.registration_number[0] : null"
            :maxlength="255"
        />

        <input-text
            label="Email"
            type="email"
            name="email"
            class="mt-3"
            v-model="form.email"
            :error="errors.email ? errors.email[0] : null"
            :maxlength="255"
        />

        <input-text
            label="Website"
            name="website"
            class="mt-3"
            v-model="form.website"
            :error="errors.website ? errors.website[0] : null"
            :maxlength="255"
        />

        <input-text
            label="Phone"
            name="phone"
            class="mt-3"
            v-model="form.phone"
            :error="errors.phone ? errors.phone[0] : null"
            :maxlength="255"
        />

        <input type="hidden" name="_token" :value="csrf" />
        <input v-if="data" type="hidden" name="_method" value="patch" />
    </form>
</template>

<script>
import crudForm from "../mixins/crudForm";
export default {
    name: "CompanyBehindForm",
    mixins: [crudForm],
    data() {
        return {
            form: {
                editor_note: this.getFormData("editor_note"),
                name: this.getFormData("name"),
                address: this.getFormData("address"),
                registration_number: this.getFormData("registration_number"),
                email: this.getFormData("email"),
                website: this.getFormData("website"),
                phone: this.getFormData("phone"),
            },
        };
    },
};
</script>
